module.exports = __webpack_public_path__ + "static/media/activity_rate.735ca229.png";